import * as React from 'react';
import { FC } from 'react';

import { ArrowButton } from 'components/arrow-button';
import { List } from 'components/list';

import noop from '../../../utils/noop';
import { ContentWrap, PageHeading } from '../support-form-v2.styled';

import { ISupportV2CategoryViewProps } from './types';

export const SupportV2CategoryView: FC<ISupportV2CategoryViewProps> = ({
  pageTitle,
  subcategories,
  onSelectSubcategory = noop,
}) => (
  <ContentWrap>
    <PageHeading aria-live="polite" data-testid="page-heading">
      {pageTitle}
    </PageHeading>

    <List data-testid="support-form-list">
      {subcategories.map(item => (
        <ArrowButton onClick={() => onSelectSubcategory(item)} key={item._id}>
          {item.name}
        </ArrowButton>
      ))}
    </List>
  </ContentWrap>
);
